// extracted by mini-css-extract-plugin
export default {"adminContainer":"Admin_adminContainer__R9kA7"};